export const FilterIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{marginTop:"6px"}}
  >
    <path
      d="M4 6H20L14 13V18L10 16V13L4 6Z"
    //   stroke="#D39A3A"
      stroke="rgb(228, 121, 7)"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const HeadPhoneIcon=()=>(
    <svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6 13V12C6 8.686 8.686 6 12 6C15.314 6 18 8.686 18 12V13"
    // stroke="#D39A3A"
     stroke="rgb(228, 121, 7)"
    strokeWidth="1.8"
    strokeLinecap="round"
  />
  <rect
    x="5"
    y="12"
    width="3"
    height="5"
    rx="1.5"
    // stroke="#D39A3A"
    stroke="rgb(228, 121, 7)"
    strokeWidth="1.8"
  />
  <rect
    x="16"
    y="12"
    width="3"
    height="6"
    rx="1.5"
    // stroke="#D39A3A"
     stroke="rgb(228, 121, 7)"
    strokeWidth="1.8"
  />
</svg>
)
export const HeadPhoneIcon2=()=>(
    <svg
  width="110"
  height="110"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
   style={{marginTop:"6px",opacity:0.3}}
>
  <path
    d="M6 13V12C6 8.686 8.686 6 12 6C15.314 6 18 8.686 18 12V13"
    stroke="#D39A3A"
    strokeWidth="1.8"
    strokeLinecap="round"
  />
  <rect
    x="5"
    y="12"
    width="3"
    height="5"
    rx="1.5"
    stroke="#D39A3A"
    strokeWidth="1.8"
  />
  <rect
    x="16"
    y="12"
    width="3"
    height="6"
    rx="1.5"
    stroke="#D39A3A"
    strokeWidth="1.8"
  />
</svg>
)
export const SortIcon=()=>(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M3 6H13" stroke="#E47907" strokeWidth="2.2" strokeLinecap="round" />
  <path d="M5 12H11" stroke="#E47907" strokeWidth="2.2" strokeLinecap="round" />
  <path d="M7 18H9" stroke="#E47907" strokeWidth="2.2" strokeLinecap="round" />

  <path d="M18 4V20" stroke="#E47907" strokeWidth="2.2" strokeLinecap="round" />
  <path
    d="M15.5 6.5L18 4L20.5 6.5"
    stroke="#E47907"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M15.5 17.5L18 20L20.5 17.5"
    stroke="#E47907"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
)